<template>
  <v-container fluid>
    <v-row no-gutters class="d-flex justify-center">
      <v-col md="12" cols="12" class="d-flex justify-space-between mb-5">
        <h2>Usuários</h2>

        <v-btn
          @click="dialogInsere = true"
          class="white--text"
          color="black"
          depressed
        >
          <v-icon>mdi-plus</v-icon>
          <div class="text-none">Adicionar</div>
        </v-btn>
      </v-col>

      <v-col md="12">
        <v-data-table
          :headers="headers"
          :items="users"
          :items-per-page="1000"
          :footer-props="{
            'items-per-page-options': [100, 250, 500, 1000, 1500, 2500],
            itemsPerPageText: 'Linhas por página',
          }"
          class="elevation-1"
          :loading="isLoading"
        >
          <template v-slot:item.acoes="{ item }">
            <div class="d-flex">
              <v-btn @click="onShowUpdate(item)" color="black" small icon>
                <v-icon size="16">mdi-pencil</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>

      <v-dialog v-model="dialogInsere" max-width="400" persistent scrollable>
        <v-card ref="form">
          <v-card-title class="text-h5"> Cadastrar usuário </v-card-title>

          <v-card-text class="grid-list">
            <v-text-field
              v-model="user.username"
              label="Nome"
              placeholder="Insira seu nome completo"
              hide-details
              outlined
              required
              dense
            />

            <v-text-field
              v-model="user.email"
              label="Email"
              placeholder="Insira seu email"
              hide-details
              required
              outlined
              dense
            />

            <v-text-field
              v-model="user.password"
              label="Senha"
              placeholder="Insira sua senha"
              type="password"
              hide-details
              required
              outlined
              dense
            />

            <v-select
              v-model="user.permissions"
              :menu-props="{ offsetY: true }"
              :items="permissionsUsers"
              label="Permissões"
              placeholder="Insira as permissões"
              content-class="select-item"
              hide-details
              required
              outlined
              multiple
              dense
              chips
            />
          </v-card-text>

          <v-card-actions>
            <v-spacer />

            <v-btn
              @click="
                resetForm();
                dialogInsere = false;
              "
              color="error"
              :disabled="isLoadingInsert"
              :loading="isLoadingInsert"
              outlined
            >
              <div class="text-none">Cancelar</div>
            </v-btn>

            <v-btn
              @click="onInsertUser"
              class="white--text"
              color="black"
              :disabled="isLoadingInsert"
              :loading="isLoadingInsert"
              depressed
            >
              <v-icon size="16" left>mdi-content-save</v-icon>
              <div class="text-none">Salvar</div>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAtualiza" persistent max-width="400">
        <v-card ref="form" v-if="userSelected">
          <v-card-title class="text-h5">
            {{
              userSelected.username
                ? `Usuário: ${userSelected.username}`
                : "Editar Usuário"
            }}
          </v-card-title>

          <v-card-text class="grid-list">
            <v-text-field
              v-model="userSelected.username"
              label="Nome"
              placeholder="Insira seu nome completo"
              hide-details
              required
              outlined
              dense
            />
            <v-text-field
              ref="name"
              v-model="userSelected.email"
              label="Email"
              placeholder="Insira seu email"
              hide-details
              required
              outlined
              dense
            />

            <v-text-field
              ref="name"
              v-model="userSelected.password"
              label="Senha"
              placeholder="Insira sua senha"
              type="password"
              hide-details
              required
              outlined
              dense
            />

            <v-select
              v-model="userSelected.permissions"
              :items="permissionsUsers"
              :menu-props="{ offsetY: true }"
              label="Permissões"
              placeholder="Insira as permissões"
              content-class="select-item"
              hide-details
              required
              outlined
              multiple
              dense
              chips
            />
          </v-card-text>

          <v-card-actions>
            <v-spacer />

            <v-btn
              @click="dialogAtualiza = false"
              color="error"
              :disabled="isLoadingUpdate"
              :loading="isLoadingUpdate"
              outlined
            >
              <div class="text-none">Cancelar</div>
            </v-btn>

            <v-btn
              @click="onUpdateUser"
              class="white--text"
              color="black"
              :disabled="isLoadingUpdate"
              :loading="isLoadingUpdate"
              depressed
            >
              <v-icon left>mdi-content-save</v-icon>
              <div class="text-none">Salvar</div>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    errorMessages: "",

    user: {
      username: null,
      email: null,
      password: null,
      permissions: [],
    },

    dialogInsere: false,

    userSelected: null,
    dialogAtualiza: false,

    isLoadingUpdate: false,

    page: 1,
    last_page: 0,
    isLoading: false,
    headers: [
      {
        text: "Nome",
        align: "start",
        value: "username",
      },
      {
        text: "Email",
        align: "start",
        value: "email",
      },
      {
        text: "Ações",
        align: "start",
        sortable: false,
        value: "acoes",
        width: 80,
      },
    ],

    users: [],
    isLoadingInsert: false,

    permissionsUsers: [
      {
        text: "Pode adicionar outras fazendas",
        value: "add_fazenda",
      },
      {
        text: "Pode remover fazendas",
        value: "remove_fazenda",
      },
    ],
  }),

  async mounted() {
    this.onLoad();
  },

  watch: {
    name() {
      this.errorMessages = "";
    },
  },

  methods: {
    ...mapActions("users", ["listUsers", "insertUser", "updateUser"]),
    async onLoad(page = 1) {
      this.page = page;
      this.isLoading = true;
      const users = await this.listUsers({ page });
      this.users = users.data.map((u) => {
        u.permissions = u.permissions.map((p) => {
          return p.name;
        });
        return u;
      });

      this.last_page = users.last_page;
      this.isLoading = false;
    },

    async onInsertUser() {
      if (!this.user.email || !this.user.username) {
        this.$eventHub.$emit("snackBar", {
          color: "error",
          message: "Preencha todos os campos",
        });
      }

      this.isLoadingInsert = true;
      const r = await this.insertUser(this.user);
      if (r) {
        this.$eventHub.$emit("snackBar", {
          color: "success",
          message: "usuário registrado com sucesso",
        });
        this.resetForm();
        this.dialogInsere = false;
        this.onLoad();
      } else {
        this.$eventHub.$emit("snackBar", {
          color: "error",
          message: "Erro ao registrar usuário",
        });
      }
      this.isLoadingInsert = false;
    },

    async onUpdateUser() {
      if (!this.userSelected.email || !this.userSelected.username) {
        this.$eventHub.$emit("snackBar", {
          color: "error",
          message: "Preencha todos os campos",
        });
      }

      this.isLoadingUpdate = true;
      const r = await this.updateUser(this.userSelected);
      if (r) {
        this.$eventHub.$emit("snackBar", {
          color: "success",
          message: "Usuário editado com sucesso",
        });
        this.resetForm();
        this.dialogAtualiza = false;
        this.onLoad();
      } else {
        this.$eventHub.$emit("snackBar", {
          color: "error",
          message: "Erro ao editar usuário",
        });
      }
      this.isLoadingUpdate = false;
    },

    onShowUpdate(user) {
      this.userSelected = user;
      this.dialogAtualiza = true;
    },

    resetForm() {
      this.user = {
        username: null,
        email: null,
        password: null,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 12px;
}
</style>
